import { Component } from 'react';

class ValueEdit extends Component {
	constructor(props) {
		super(props)
		this.state = {
			editing: this.props.editing || false,
			value: this.props.text || ''
		};
	}

	onSubmit(e) {
		let { onSet } = this.props
		let { value } = this.state
		e.preventDefault();
		onSet(value)
		this.setState({editing: false})
	}

	onClick() {
		this.setState({editing:true})
	}

	onChange(e) {
		this.setState({value: e.target.value})
	}

	render() {
		let { buttonText, placeholder } = this.props
		let { editing, value } = this.state
		if (editing) {
			return <form onSubmit={ e => this.onSubmit(e) }>
				<input type="text" placeholder={placeholder} value={value} onChange={e => this.onChange(e)}/>
				<button>{buttonText}</button>
			</form>
		} else {
			return <a href="javascript:void(0)" onClick={() => this.onClick()}>{value.split(',').slice(0, 2).join(',')}</a>
		}
	}
}

ValueEdit.defaultProps = {
	placeholder: "enter location",
	text: ""
}

export default class conditions extends Component {

	render() {
		let { today, tomorrow, todaysDate, locationText } = this.props;
		if (!locationText) {
			return <ValueEdit editing={true} buttonText="get relative weather" onSet={this.props.onSetLocation}/>
		}
		return <div>
			<header>
				<span>Right now in </span>
				<ValueEdit text={locationText} buttonText="change location" onSet={this.props.onSetLocation}/>
				<span> {"it's"}</span>
				<ul class='today'>{today.map( (c, i) => <li>{(i === (today.length - 1) ? '& ' : '') + c}</li> )}</ul>
				<span>than yesterday <span class='time'>{todaysDate}</span>.</span>
			</header>
			<header className="tomorrow">
				<span>{`Tomorrow ${todaysDate} it'll be`}</span>
				<ul className='tomorrow'>{tomorrow.map( (c, i) => <li>{(i === (tomorrow.length - 1) ? '& ' : '') + c + (i === (tomorrow.length - 1) ? '.' : '')}</li> )}</ul>
			</header>
			<a class="credits" href="https://darksky.net/poweredby/">Powered by Dark Sky</a>
		</div>
	}
}

conditions.defaultProps = {
	today: [],
	tomorrow: [],
	locationText: '',
	todaysDate: ''
};


/** WEBPACK FOOTER **
 ** ./conditions.jsx
 **/